/*
 *
 * ManageUserModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 15-Jan-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  cancel: <PortalMessage id='t.app.settings.createUser.btnCancel' defaultMessage='Cancel' />,
  save: <PortalMessage id='t.app.settings.createUser.btnSave' defaultMessage='Save' />,
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  create: <PortalMessage id='t.app.project.btn.add' defaultMessage='Add' />,
  titleManage: <PortalMessage id='t.app.settings.popup.users.manage.title' defaultMessage='Manage User' />,
  titleCreate: <PortalMessage id='t.app.settings.popup.users.manage.titleCreate' defaultMessage='Add user' />,
  email: <PortalMessage id='t.app.settings.users.email' defaultMessage='Email' />,
  name: <PortalMessage id='t.app.settings.users.name' defaultMessage='name' />,
  role: <PortalMessage id='t.app.settings.users.role' defaultMessage='User role' />,
  activated: <PortalMessage id='t.app.settings.users.activated' defaultMessage='ENABLE' />,
  deactivated: <PortalMessage id='t.app.settings.users.deactivated' defaultMessage='DISABLE' />,
  generalInfo: <PortalMessage id='t.app.settings.popup.users.manage.generalInfo' defaultMessage='User data' />
}

export const messages = {
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}

export const captions = defineMessages({
  validEmail: { id: 't.app.settings.createUser.validEmail', defaultMessage: 'Invalid email address' },
  validName: { id: 't.app.settings.createUser.validName', defaultMessage: 'Invalid characters:' },
  validRole: { id: 't.app.settings.createUser.validRole', defaultMessage: 'User role is a required field' },
  status: { id: 't.app.accessibility.settings.users.status.ariaLabel', defaultMessage: 'Status' },
  ariaTitleManage: {
    id: 't.app.settings.popup.users.manage.ariaTitle',
    defaultMessage: 'Manage User'
  },
  ariaTitleCreate: {
    id: 't.app.settings.popup.users.manage.ariaTitleCreate',
    defaultMessage: 'Create new User title: Create new User'
  },
  activated: {
    id: 't.app.settings.users.activated',
    defaultMessage: 'ENABLE'
  },
  deactivated: {
    id: 't.app.settings.users.deactivated',
    defaultMessage: 'DISABLE'
  },
  role: {
    id: 't.app.settings.users.role',
    defaultMessage: 'role'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  admin: {
    id: 't.app.settings.users.role.admin',
    defaultMessage: 'Admin'
  },
  operator: {
    id: 't.app.settings.users.role.operator',
    defaultMessage: 'Operator'
  },
  reporter: {
    id: 't.app.settings.users.role.viewer',
    defaultMessage: 'Viewer'
  },
  email: {
    id: 't.app.settings.users.email',
    defaultMessage: 'Email'
  },
  name: {
    id: 't.app.settings.users.name',
    defaultMessage: 'name'
  }
})

export const tooltips = defineMessages({
  roleTooltipMainTitle: { id: 't.app.settings.users.roleTooltipMainTitle', defaultMessage: 'Select the user role:' },
  roleTooltipAdminTitle: {
    id: 't.app.settings.users.roleTooltipAdminTitle',
    defaultMessage: 'admin:'
  },
  roleTooltipAdminDescription: {
    id: 't.app.settings.users.roleTooltipAdminDescription',
    defaultMessage: 'User authorized to perform payment actions and configure terminals.'
  },
  roleTooltipOperatorTitle: {
    id: 't.app.settings.users.roleTooltipOperatorTitle',
    defaultMessage: 'operator:'
  },
  roleTooltipOperatorDescription: {
    id: 't.app.settings.users.roleTooltipOperatorDescription',
    defaultMessage: 'User authorized to perform payment actions.'
  },
  roleTooltipViewerTitle: {
    id: 't.app.settings.users.roleTooltipViewerTitle',
    defaultMessage: 'viewer:'
  },
  roleTooltipViewerDescription: {
    id: 't.app.settings.users.roleTooltipViewerDescription',
    defaultMessage: 'User authorized to view orders and payment transactions.'
  }
})
export default formattedMessage
